import { render, staticRenderFns } from "./SettingsSistema.vue?vue&type=template&id=3a8c4e5c"
import script from "./SettingsSistema.vue?vue&type=script&lang=js"
export * from "./SettingsSistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8c4e5c')) {
      api.createRecord('3a8c4e5c', component.options)
    } else {
      api.reload('3a8c4e5c', component.options)
    }
    module.hot.accept("./SettingsSistema.vue?vue&type=template&id=3a8c4e5c", function () {
      api.rerender('3a8c4e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/settings/SettingsSistema.vue"
export default component.exports